// /home/szymon/kreator2/frontend/src/components/editor/Rulers.js
// v9.4.0 – cyfry przeniesione na zewnątrz linijek

import React from 'react';

export const RULER_SIZE = 20;
const PX_PER_CM_72 = 72 / 2.54;

/**
 * Rysuje poziomą linijkę (co 0.5 cm) z cyframi na zewnątrz (u góry).
 */
export function HorizontalRuler({ baseWidth, zoomFactor }) {
  const pxPerCm = PX_PER_CM_72 * zoomFactor;
  const totalPx = baseWidth * zoomFactor;
  const cmCount = Math.floor(totalPx / pxPerCm);

  const elements = [];

  for (let halfStep = 1; halfStep <= cmCount * 2; halfStep++) {
    const xPos = Math.round((halfStep * pxPerCm) / 2);
    const isFullCm = halfStep % 2 === 0; // co 1cm
    const shortLen = 0.4 * RULER_SIZE;
    const longLen = shortLen * 1.3;
    const lineLen = isFullCm ? longLen : shortLen;

    // Kreska
    elements.push(
      <div
        key={`hr-line-${halfStep}`}
        style={{
          position: 'absolute',
          left: xPos,
          top: 0,
          width: 1,
          height: lineLen,
          backgroundColor: '#000'
        }}
      />
    );

    // Cyfra – ustawiamy wyżej (negatywny top), żeby była "na zewnątrz" linijki
    if (isFullCm) {
      const cmNumber = halfStep / 2;
      elements.push(
        <div
          key={`hr-num-${halfStep}`}
          style={{
            position: 'absolute',
            left: xPos,
            top: -14, // przeniesienie nad linijkę
            transform: 'translateX(-50%)',
            fontSize: 10,
            color: '#000'
          }}
        >
          {cmNumber}
        </div>
      );
    }
  }

  return (
    <div
      style={{
        position: 'relative',
        width: totalPx,
        height: RULER_SIZE,
        backgroundColor: '#fff'
      }}
    >
      {elements}
    </div>
  );
}

/**
 * Rysuje pionową linijkę (co 0.5 cm) z cyframi na zewnątrz (po lewej).
 */
export function VerticalRuler({ baseHeight, zoomFactor }) {
  const pxPerCm = PX_PER_CM_72 * zoomFactor;
  const totalPx = baseHeight * zoomFactor;
  const cmCount = Math.floor(totalPx / pxPerCm);

  const elements = [];

  for (let halfStep = 1; halfStep <= cmCount * 2; halfStep++) {
    const yPos = Math.round((halfStep * pxPerCm) / 2);
    const isFullCm = halfStep % 2 === 0;
    const shortLen = 0.4 * RULER_SIZE;
    const longLen = shortLen * 1.3;
    const lineLen = isFullCm ? longLen : shortLen;

    // Kreska
    elements.push(
      <div
        key={`vr-line-${halfStep}`}
        style={{
          position: 'absolute',
          top: yPos,
          left: 0,
          width: lineLen,
          height: 1,
          backgroundColor: '#000'
        }}
      />
    );

    // Cyfra – ustawiamy w lewo (negatywny left), by była "na zewnątrz" linijki
    if (isFullCm) {
      const cmNumber = halfStep / 2;
      elements.push(
        <div
          key={`vr-num-${halfStep}`}
          style={{
            position: 'absolute',
            top: yPos,
            left: -14, // na zewnątrz linijki
            transform: 'translateY(-50%)',
            fontSize: 10,
            color: '#000'
          }}
        >
          {cmNumber}
        </div>
      );
    }
  }

  return (
    <div
      style={{
        position: 'relative',
        width: RULER_SIZE,
        height: totalPx,
        backgroundColor: '#fff'
      }}
    >
      {elements}
    </div>
  );
}
